// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--mOabU","title":"_9e1425b4d3--title--QZpx4","description":"_9e1425b4d3--description--b9pZd","switch-wrapper":"_9e1425b4d3--switch-wrapper--aoV9z"};